(function() {
  // Add custom code below this line

  /* ============================================================
     Collection UX v4 — Terminal-X style navigation + smooth
     infinite scroll.
     - URL quietly tracks the current page (?page=N) while scrolling.
     - Product click stamps its page + remembers the product;
       coming back lands straight on it (server renders that page).
     - Earlier pages auto-load above (no button).
     - Forward loading: triggers ~1.5 screens before the bottom,
       fetches only the collection section (section_id — much
       faster), and shows skeleton cards if the user outruns it.
     ============================================================ */
  (function () {
    if (!document.body || !document.body.classList.contains('template-collection')) return;

    var GRID = '#AjaxinateLoop';
    var PAGINATION = '#AjaxinatePagination';
    var ANCHOR_KEY = 'miaCollAnchor';
    var TTL = 30 * 60 * 1000;

    var grid = document.querySelector(GRID);
    if (!grid || !grid.children.length) return; // infinite scroll off / empty

    var perPage = grid.children.length; // items per server-rendered page window
    var basePage = getUrlPage();        // the page this DOM was rendered from
    var minPage = basePage;             // lowest page currently in the DOM

    var sectionEl = grid.closest('[id^="shopify-section-"]');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;

    function getUrlPage() {
      var p = parseInt(new URLSearchParams(location.search).get('page'), 10);
      return p > 0 ? p : 1;
    }

    function urlForPage(p) {
      var url = new URL(location.href);
      if (p > 1) { url.searchParams.set('page', p); } else { url.searchParams.delete('page'); }
      return url.toString();
    }

    // Same as urlForPage but returns only the collection section — much lighter
    function sectionUrlForPage(p) {
      var url = new URL(urlForPage(p));
      if (sectionId) url.searchParams.set('section_id', sectionId);
      return url.toString();
    }

    // Run a scroll command with smooth-scrolling temporarily off
    // (theme.css sets `html { scroll-behavior: smooth; }`)
    function noScrollAnim(fn) {
      var doc = document.documentElement;
      doc.style.scrollBehavior = 'auto';
      fn();
      setTimeout(function () { doc.style.scrollBehavior = ''; }, 100);
    }

    // Keep scrolling instant while the restore machinery is active;
    // smooth scrolling returns 1.5s after the last programmatic move
    var instantTimer = null;
    function holdInstantScroll() {
      document.documentElement.style.scrollBehavior = 'auto';
      clearTimeout(instantTimer);
      instantTimer = setTimeout(function () {
        document.documentElement.style.scrollBehavior = '';
      }, 1500);
    }

    // Which page window does a direct grid child belong to
    function itemPage(item) {
      var i = [].indexOf.call(grid.children, item);
      if (i === -1) return null;
      return minPage + Math.floor(i / perPage);
    }

    // ---- 1. URL quietly tracks the page you are looking at ----
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(function () {
        ticking = false;
        var mid = window.innerHeight / 2;
        var items = grid.children;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          if (r.bottom >= mid) {
            var p = minPage + Math.floor(i / perPage);
            if (p !== getUrlPage()) {
              try { history.replaceState(history.state, '', urlForPage(p)); } catch (e) {}
            }
            break;
          }
        }
      }, 200);
    }, { passive: true });

    // ---- 2. Product click: stamp its page + remember the product ----
    grid.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!link) return;
      var item = link;
      while (item.parentElement && item.parentElement !== grid) item = item.parentElement;
      var p = itemPage(item) || getUrlPage();
      try { history.replaceState(history.state, '', urlForPage(p)); } catch (err) {}
      try {
        sessionStorage.setItem(ANCHOR_KEY, JSON.stringify({
          href: link.pathname,
          list: location.pathname,
          t: Date.now()
        }));
      } catch (err) {}
    }, true);

    // ---- 3. Back navigation: jump straight to the product ----
    var navEntries = (performance.getEntriesByType && performance.getEntriesByType('navigation')) || [];
    if (navEntries.length && navEntries[0].type === 'back_forward') {
      var raw = null;
      try { raw = sessionStorage.getItem(ANCHOR_KEY); } catch (e) {}
      if (raw) {
        try {
          var anchor = JSON.parse(raw);
          if (anchor && anchor.list === location.pathname && Date.now() - (anchor.t || 0) < TTL) {
            var target = grid.querySelector('a[href*="' + anchor.href + '"]');
            if (target) {
              if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
              // Pin the product to the center for ~0.8s while the banner
              // and images finish loading — late layout shifts cause no jump
              var lockUntil = performance.now() + 1200;
              var lockOff = false;
              ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
                window.addEventListener(evt, function () { lockOff = true; }, { passive: true, once: true });
              });
              (function lock() {
                if (lockOff) return;
                holdInstantScroll();
                target.scrollIntoView({ block: 'center' });
                if (performance.now() < lockUntil) requestAnimationFrame(lock);
              })();            }
          }
        } catch (e) {}
      }
    }

   
    // ---- 4. Load earlier pages automatically (no button) ----
    // Fills products above the landing point right away so it never
    // looks like the top of the list; more pages load nearing the top.
    var loadingPrev = false;
    function loadPrev() {
      if (loadingPrev || minPage <= 1) return;
      loadingPrev = true;
      var pre = window.__miaPrevPages && window.__miaPrevPages[minPage - 1];
      if (pre) { delete window.__miaPrevPages[minPage - 1]; }
      (pre || fetch(sectionUrlForPage(minPage - 1), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); }))
        .then(function (html) {
          if (!html) { throw new Error('empty prefetch'); }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector(GRID);
          if (!newGrid) throw new Error('no grid in response');
          var before = document.documentElement.scrollHeight;
          var prevY = window.scrollY;
          grid.insertAdjacentHTML('afterbegin', newGrid.innerHTML);
          minPage--;
          var delta = document.documentElement.scrollHeight - before;
          holdInstantScroll();
          window.scrollTo(0, prevY + delta);
          rebindItemEvents();
          setTimeout(function () {
            loadingPrev = false;
            if (window.__miaPrevPages && window.__miaPrevPages[minPage - 1]) { loadPrev(); }
          }, 300);
        })
        .catch(function () { loadingPrev = false; });
    }
    window.addEventListener('scroll', function () {
      if (window.scrollY <= 600) loadPrev();
    }, { passive: true });
    window.addEventListener('wheel', function (e) {
      if (e.deltaY < 0 && window.scrollY <= 600) loadPrev();
    }, { passive: true });

    // "Scroll to top" must mean the REAL top of the collection:
    // if earlier pages are not loaded yet, go straight to page 1
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-scroll-top-button]');
      if (!btn || minPage <= 1) return;
      e.preventDefault();
      e.stopPropagation();
      location.href = urlForPage(1);
    }, true);

    // Landed mid-list (?page=N) — fill one page above immediately,
    // while the loading overlay is still covering the screen
    if (basePage > 1) {
      loadPrev();
    }

    // Force one natural Ajaxinate load so the theme's callback rebinds
    // item events (quick view) over injected products.
    function rebindItemEvents() {
      try {
        var pag = document.querySelector(PAGINATION);
        if (!pag || !pag.querySelector('a')) return;
        var style = pag.getAttribute('style') || '';
        pag.setAttribute('style', 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;');
        document.dispatchEvent(new Event('scroll'));
        setTimeout(function () { document.dispatchEvent(new Event('scroll')); }, 200);
        setTimeout(function () {
          if (style) { pag.setAttribute('style', style); } else { pag.removeAttribute('style'); }
        }, 450);
      } catch (e) { /* non-critical */ }
    }

    // ---- 5. Smooth forward infinite scroll ----
    var pagEl = document.querySelector(PAGINATION);
    if (pagEl) {
      // (a) Early trigger: extend the sentinel's box 300vh upward so
      // Ajaxinate starts loading ~3 screens before the bottom.
      // Padding + negative margin cancel out — zero visual change.
      pagEl.style.paddingTop = '300vh';
      pagEl.style.marginTop = '-300vh';
      pagEl.style.pointerEvents = 'none'; // don't block clicks on products above

      // (b) Light requests: rewrite the next-page link so Ajaxinate
      // fetches only the collection section instead of the full page.
      function fixPaginationLink() {
        if (!sectionId) return;
        var a = pagEl.querySelector('a');
        if (!a) return;
        try {
          var u = new URL(a.getAttribute('href'), location.origin);
          if (!u.searchParams.get('section_id')) {
            u.searchParams.set('section_id', sectionId);
            a.setAttribute('href', u.pathname + u.search);
          }
        } catch (e) {}
      }
      fixPaginationLink();

      // (c) Skeleton cards for the rare case the user outruns the fetch
      var skel = null;
      var skelStyle = document.createElement('style');
      skelStyle.textContent = '@keyframes miaSkelPulse{0%,100%{opacity:1}50%{opacity:.45}}' +
        '#AjaxinatePagination .pagination__loading{opacity:0 !important;}';
      document.head.appendChild(skelStyle);

      function showSkeletons() {
        if (skel) return;
        var itemW = grid.children[0] ? grid.children[0].getBoundingClientRect().width : 0;
        var cols = itemW > 0 ? Math.max(1, Math.round(grid.getBoundingClientRect().width / itemW)) : 4;
        skel = document.createElement('div');
        skel.style.cssText = 'display:grid;grid-template-columns:repeat(' + cols + ',1fr);gap:12px;margin:12px 0;';
        for (var i = 0; i < cols * 2; i++) {
          var c = document.createElement('div');
          c.style.cssText = 'aspect-ratio:2/3;background:#f2f2f2;border-radius:6px;animation:miaSkelPulse 1.2s ease-in-out infinite;';
          skel.appendChild(c);
        }
        grid.insertAdjacentElement('afterend', skel);
      }
      function hideSkeletons() {
        if (skel) { skel.remove(); skel = null; }
      }

      // After each Ajaxinate load: re-apply the section_id rewrite.
      // While loading ("Loading" indicator): show skeletons.
      new MutationObserver(function () {
        fixPaginationLink();
        var a = pagEl.querySelector('a');
        if (a && /loading/i.test(a.textContent)) { showSkeletons(); }
      }).observe(pagEl, { childList: true, subtree: true, characterData: true });

      // New products arrived — skeletons out + start downloading the
      // first items' main images right away (less visible pop-in)
      new MutationObserver(function (muts) {
        var added = [];
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            if (muts[i].addedNodes[j].nodeType === 1) added.push(muts[i].addedNodes[j]);
          }
        }
        if (!added.length) return;
        hideSkeletons();
        added.slice(0, 12).forEach(function (node) {
          var img = node.querySelector && node.querySelector('img');
          if (img) { img.loading = 'eager'; img.setAttribute('fetchpriority', 'low'); }
        });
      }).observe(grid, { childList: true });
    }
  })();
  /* ============================================================
     Flashy popups live in the browser's TOP LAYER
     Flashy renders every popup as <flashy-popup> → shadow DOM →
     <dialog> opened with showModal(). A modal dialog sits in the
     browser's top layer, above every z-index on the page — so no
     z-index change in the theme can put the cart drawer over it.
     Instead: while our cart/nav drawer is open, close the popup.
     ============================================================ */
  (function () {
    function drawerOpen() {
      return document.body.classList.contains('js-drawer-open-cart') ||
             document.body.classList.contains('js-drawer-open');
    }
    function closeFlashyPopups() {
      if (!drawerOpen()) return;
      document.querySelectorAll('flashy-popup').forEach(function (host) {
        var dlg = host.shadowRoot && host.shadowRoot.querySelector('dialog[open]');
        if (dlg) { try { dlg.close(); } catch (e) {} }
      });
    }
    function sweep() {
      closeFlashyPopups();
      setTimeout(closeFlashyPopups, 150);
      setTimeout(closeFlashyPopups, 600);
    }
    new MutationObserver(sweep).observe(document.body, {
      childList: true, attributes: true, attributeFilter: ['class']
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call
})();